module.exports = __webpack_public_path__ + "static/img/PrestationSoin3.0ab39fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PrestationSoin3.jpg
// module id = EIep
// module chunks = 1